// extracted by mini-css-extract-plugin
export var BlogPostsGrid = "BlogPostsGrid-module--BlogPostsGrid--6wI0D";
export var aniSpin = "BlogPostsGrid-module--ani-spin--ly6rK";
export var column = "BlogPostsGrid-module--column--MuK9M";
export var heading = "BlogPostsGrid-module--heading--iND4U";